import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import './styles/global.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from the page');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
